module.exports = __webpack_public_path__ + "img/grim-reaper-hood.e16d7fbb.png";